module.exports = __webpack_public_path__ + "public/b8af20841013c278a953b19c9c85f292.woff";